module.exports = __webpack_public_path__ + "img/truck-clock.74f70a99.svg";